export const defaultEnrolment = {
    customerId: null,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    familyId: null,
    memberId: null,
    termId: null,
    classId: null,
    sectionId: null,
}
